import {
    AnalyticsRequest,
    Metric,
    GroupBy,
    Sort,
} from '../../PanelTemplatesTheme/PanelTemplatesTheme';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from 'components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';
import { DefaultWidgetPosition } from '../../PanelTemplatesTheme/constants';

export const HyperSpaceStackedBarChart: Widget = {
    type: 'hyperSpaceStackedBarChart',
    id: 'hyper-space-stacked-bar-chart',
    name: 'Stacked Bar Chart',
    useGlobalTimePeriod: true,
    useGlobalTranslate: true,
    translationLanguage: null,
    analyticsRequests: [
        new AnalyticsRequest({
            projections: [
                new Metric({
                    ADVOCACY: { dimensionName: 'POINTS' },
                    STORY_MESSAGE: { dimensionName: 'NEWS_COUNT', heading: 'Mentions' },
                    SPR_TASK: {
                        dimensionName: 'DOC_COUNT',
                        heading: 'Task Count',
                    },
                }),
            ],
            limit: 2000,
            groupBys: [
                new GroupBy({
                    LISTENING: {
                        source: ListeningDimensions.topicName,
                        limitType: 'TOP',
                        limit: 16,
                    },
                    INBOUND_MESSAGE: {
                        dimensionName: 'ACCOUNT_ID',
                        limitType: 'TOP',
                        limit: 16,
                    },
                    PLATFORM: { dimensionName: 'ACCOUNT_ID', limitType: 'TOP', limit: 16 },
                    BENCHMARKING: {
                        dimensionName: 'BENCHMARKING_ACCOUNT_ID',
                        limitType: 'TOP',
                        limit: 16,
                    },
                    PAID: { dimensionName: 'accountIds', limitType: 'TOP', limit: 16 },
                    ADVOCACY: {
                        dimensionName: 'COMMUNITY_USER_ID',
                        limitType: 'TOP',
                        limit: 16,
                    },
                    RDB_FIREHOSE: {
                        dimensionName: 'DAY_OF_WEEK',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    STORY_MESSAGE: {
                        dimensionName: 'PUBLICATION_NAME',
                        limitType: 'TOP',
                        limit: 16,
                    },
                    SPR_TASK: {
                        dimensionName: 'DAY_OF_WEEK',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    COMMUNITY: {
                        source: ListeningDimensions.activityDate,
                        dimensionName: 'date',
                    },
                    SAM: {
                        source: ListeningDimensions.account,
                        dimensionName: 'ACCOUNT_ID',
                    },
                    AUDIENCE_ACTIVITY: {
                        dimensionName: 'DAY_OF_WEEK',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    OUTBOUND_MESSAGE: {
                        source: ListeningDimensions.account,
                        dimensionName: 'ACCOUNT_ID',
                    },
                    CONSUMPTION: {
                        dimensionName: 'DAY_OF_WEEK',
                        limitType: 'TOP',
                        limit: 8,
                    },
                }),
                new GroupBy({
                    LISTENING: {
                        source: ListeningDimensions.socialNetwork,
                        limitType: 'TOP',
                        limit: 8,
                    },
                    INBOUND_MESSAGE: {
                        dimensionName: 'SN_TYPE',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    PLATFORM: { dimensionName: 'SN_TYPE', limitType: 'TOP', limit: 8 },
                    BENCHMARKING: {
                        dimensionName: 'BENCHMARKING_SN_TYPE',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    PAID: {
                        dimensionName: 'socialChannelTypes',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    ADVOCACY: {
                        dimensionName: 'AUDIENCE_ACTIVITY_TYPE',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    RDB_FIREHOSE: {
                        dimensionName: 'RDB_QUERY_IDS',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    STORY_MESSAGE: {
                        dimensionName: 'SENTIMENT',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    SPR_TASK: { dimensionName: 'ASSIGNEE_ID', limitType: 'TOP', limit: 8 },
                    COMMUNITY: {
                        source: ListeningDimensions.activity,
                        limitType: 'TOP',
                        limit: 8,
                    },
                    SAM: {
                        dimensionName: 'ASSET_TYPE',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    AUDIENCE_ACTIVITY: {
                        dimensionName: 'ACCOUNT_ID',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    OUTBOUND_MESSAGE: {
                        dimensionName: 'MEDIA_TYPE',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    CONSUMPTION: {
                        dimensionName: 'ACTIVITY_TYPE',
                        limitType: 'TOP',
                        limit: 8,
                    },
                }),
            ],
            sorts: [
                new Sort({ order: 'DESC', projections: 0 }),
                new Sort({ order: 'ASC', groupBys: 0 }),
            ],
            timePeriods: [{ key: 'last_7_days' }],
            // additional: {
            //     STACKED: true,
            // },
        }) as any,
    ],
    position: DefaultWidgetPosition,
    label: {
        titleText: 'Stacked Bar Chart',
        size: WIDGET_LABEL_SIZE.primary,
        enabled: false,
    },
    options: {
        player: {
            playing: true,
            duration: 15,
        },
        includeMetrics: false,
        zeroFill: true,
        baseXYChartOptions: {
            grid: {
                enabled: false,
            },
            xAxis: {
                ticks: {
                    formats: {
                        numberFormat: {
                            decimals: 0,
                            useShortened: true,
                        },
                        dateFormat: {
                            autoFormat: true,
                            formatString: 'dd MMM',
                        },
                    },
                    numTicks: 5,
                },
                enabled: true,
                label: {
                    enabled: true,
                    size: 50,
                },
                line: {
                    enabled: false,
                    stroke: '',
                    strokeWidth: 1,
                },
            },
            yAxis: {
                ticks: {
                    formats: {
                        numberFormat: {
                            decimals: 0,
                            useShortened: true,
                        },
                        dateFormat: {
                            autoFormat: true,
                            formatString: 'dd MMM',
                        },
                    },
                    numTicks: 5,
                },
                enabled: true,
                label: {
                    enabled: true,
                    size: 50,
                },
                line: {
                    enabled: false,
                    stroke: '',
                    strokeWidth: 1,
                },
            },
        },
    },
};
